import registerIcon from "../components/icon";
import registerDropdown from "../components/dropdown";
import registerFormElements from "../components/form";
import registerRenderOn from "../components/renderOn";
import registerLangSelect from "../components/languageSelect";
import registerLoadingDir from "../directives/loading";
import registerScrollToDir from "../directives/scrollTo";
import registerShowOnInteractiveDir from "../directives/showOnInteractive";
import registerWin from "../components/win";
import registerMsg from "../components/msg";
import registerReview from "../components/review";
import registerInview from "../components/inview";
import registerFixedShare from "../components/fixedShare";
import registerSubheader from "../components/subheader";
import LazyLoad from "./lazyLoad";

new LazyLoad({
  el: ".right-bar",
  onScroll: true,
  componentFactory() {
    return import("../components/rightBar");
  },
});

new LazyLoad({
  el: ".ai-service",
  onScroll: true,
  componentFactory() {
    return import("../components/aiService");
  },
});

// 组件注册顺序影响组件调用
const components = [
  registerWin, // 注册优先级最高
  registerInview, // ?
  registerFixedShare, //固定的分享列表
  registerSubheader, // 产品页面的subheader
  registerShowOnInteractiveDir, // 交互时显示元素
  registerLoadingDir, // loading
  registerScrollToDir,
  registerReview, // 评论
  registerMsg, // message
  registerRenderOn, //
  registerIcon,
  registerDropdown,
  registerFormElements,
  registerLangSelect,
];

export default components;
